export default __webpack_public_path__ + "static/media/colors-1440w.b599a1e4.webp";